"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function () {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const regions = [{
    city: "Vancouver",
    code: "VAN",
    cx: 24,
    cy: 38
  }, {
    city: "Burnaby",
    code: "BRN",
    cx: 47,
    cy: 32
  }, {
    city: "Surrey",
    code: "SRY",
    cx: 49,
    cy: 36
  }, {
    city: "Richmond",
    code: "RCH",
    cx: 82,
    cy: 39
  }, {
    city: "Coquitlam",
    code: "CQT",
    cx: 75,
    cy: 58
  }];
  return;
}